import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Table } from 'react-bootstrap';
import { isNumber } from 'lodash';
import styles from './styles.css';
import messages from './messages';

export const formatNumber = (number) => {
  if (isNumber(number) && number !== 0) {
    return `$${number.toFixed(2)}`;
  }
  return '$0.00';
};

const TransferFeesPanel = ({ fees }) => (
  <div className={styles.feePanel} test-data-handle="transfer-fees-panel">
    <Table>
      <thead className={styles['feePanel-header']}>
        <tr>
          <th className={styles['feePanel-header__type']}>Type</th>
          <th className={styles['feePanel-header__fee']}>Customer Debit</th>
          <th className={styles['feePanel-header__fee']}>Correspondent Net</th>
          <th className={styles['feePanel-header__fee']}>Apex Credit</th>
        </tr>
      </thead>
      <tbody className={styles['feePanel-body']}>
        {fees &&
          fees.map((fee) => (
            <tr
              key={`${fee.type}-${fee.apexCreditAmount}`}
              test-data-handle="fee-row"
              className={styles['feePanel-body__row']}
            >
              <td test-data-handle={`fee-${fee.type}`}>
                <FormattedMessage {...messages[fee.type]} />
              </td>
              <td className={styles['feePanel-body__row__fee']} test-data-handle="fee-customer-debit">
                {formatNumber(fee.customerDebitAmount)}
              </td>
              <td className={styles['feePanel-body__row__fee']} test-data-handle="fee-correspondent-net">
                {formatNumber(fee.correspondentNetAmount)}
              </td>
              <td className={styles['feePanel-body__row__fee']} test-data-handle="fee-apex-credit">
                {formatNumber(fee.apexCreditAmount)}
              </td>
            </tr>
          ))}
      </tbody>
    </Table>
    {fees.length <= 0 && (
      <div className={styles['feePanel-no-fee']} test-data-handle="no-fees">
        <FormattedMessage {...messages.noFees} />{' '}
      </div>
    )}
  </div>
);

TransferFeesPanel.propTypes = {
  fees: PropTypes.array,
};

TransferFeesPanel.defaultProps = {
  fees: [],
};

export default TransferFeesPanel;



// WEBPACK FOOTER //
// ./src/components/TransferFeesPanel/index.js